import { __rest, __assign } from '../../../_virtual/_tslib.js';
import React from 'react';
import DesktopModal from './DesktopModal/DesktopModal.js';
import MobileModal from './MobileModal/MobileModal.js';
import { useIsDesktop } from '../../../utils/common/screen.js';

/**
 * the children should be an html element that accepts ref. `ModalContent` handles that itself
 */
var Modal = function (_a) {
    var children = _a.children, _b = _a.onClose, onCloseProp = _b === void 0 ? function () { } : _b, closeOnEscapeKeyDown = _a.closeOnEscapeKeyDown, closeOnBackdropClick = _a.closeOnBackdropClick, forceDesktopDesign = _a.forceDesktopDesign, rest = __rest(_a, ["children", "onClose", "closeOnEscapeKeyDown", "closeOnBackdropClick", "forceDesktopDesign"]);
    var isDesktop = useIsDesktop();
    var onClose = function (e, reason) {
        if (reason === "escapeKeyDown" && !closeOnEscapeKeyDown)
            return;
        if (reason === "backdropClick" && !closeOnBackdropClick)
            return;
        onCloseProp(e);
    };
    var ModalComponent = isDesktop || forceDesktopDesign ? DesktopModal : MobileModal;
    return (React.createElement(ModalComponent, __assign({ onClose: onClose }, rest), children));
};

export { Modal as default };
//# sourceMappingURL=Modal.js.map
